import { Category } from "../../lib/types";

export default function getCategoryFromId(categoryId: number): Category {
  return VisitWidget.store.categories.find(
    (category) => category.id === categoryId,
  );
}
